<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <span class="text-info" role="button" @click="menuBreadcrumb(0)"
                >Home</span
              >
            </li>
            <li
              v-show="tela == 1"
              class="breadcrumb-item active"
              aria-current="page"
            >
              Enviar Assinatura
            </li>
            <li
              v-show="tela == 2"
              @click="menuBreadcrumb(1)"
              class="breadcrumb-item"
            >
              <span class="text-info" role="button">Enviar Assinatura</span>
            </li>
            <li
              v-show="tela == 2"
              class="breadcrumb-item active"
              aria-current="page"
            >
              Cartão de Ponto
            </li>
          </ol>
        </nav>

        <!-- TELA DE FILTRO-->
        <card card-body-classes="table-full-width" v-if="tela == 1">
          <h4 slot="header" class="card-title text-left">
            ENVIAR PARA ASSINATURA
          </h4>
          <div class="row pl-4 pr-4">
            <BaseFiltroPonto
              class="col-sm-6 col-12"
              @imprimir="imprimir"
              @pesquisar="pesquisar"
              :periodo="periodo"
            />
            <div class="offset-sm-6 "></div>
          </div>
        </card>
        <!-- TELA DE RESULTADO-->
        <card
          card-body-classes="table-full-width"
          v-if="tela == 2"
          id="imprimirFolha"
        >
          <div class="row p-1 hidden-print" v-show="!printing">
            <div class="col-4 form-group text-left has-label ">
              <label>
                Destino do Cartão de Ponto
              </label>
              <el-select
                class="select-success mb-3 pagination-select"
                placeholder="Destino do Cartão de Ponto"
                v-model="payloadEnvio.destinoSelecionado"
              >
                <el-option
                  v-for="item in destino"
                  :key="item.id"
                  class="select-success"
                  :label="item.descricao"
                  :value="item.id"
                  >{{ item.descricao }}</el-option
                >
              </el-select>
            </div>

            <div class="col-3 offset text-left pt-3 pl-0 ml-0">
              <base-button
                type="success"
                class="text-center animation-on-hover"
                @click="processar()"
                >Processar</base-button
              >
            </div>
          </div>

          <BaseCartaoPonto
            v-if="dados.length && dados[0].config.layoutAjustePonto == 1"
            v-for="item in dados"
            :key="item.dadosEmpregado.cpf"
            class="break"
            :dados="item"
            :periodo="periodo"
            :printing="printing"
            :modoVisualizacao="true"
            @atualizarTable="atualizarTable"
          >
          </BaseCartaoPonto>

          <BaseCartaoPontoSemsa
            v-if="dados.length && dados[0].config.layoutAjustePonto == 2"
            v-for="item in dados"
            :key="item.dadosEmpregado.cpf"
            :dados="item"
            :periodo="periodo"
            :printing="printing"
            @atualizarTable="atualizarTable"
          >
          </BaseCartaoPontoSemsa>

          <Paginacao
            v-show="!printing"
            :currentPage="pagination.currentPage"
            :totalPages="pagination.totalPages"
            @page-changed="carregarCartaoDePonto"
          />
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseInput,
  BaseFiltroPonto,
  BaseCartaoPonto,
  BaseCartaoPontoSemsa,
  Paginacao,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroPonto,
    BaseCartaoPonto,
    BaseCartaoPontoSemsa,
    Paginacao,
  },
  computed: {},
  data() {
    return {
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalItems: 0,
        totalPages: 0,
      },
      payloadEnvio: {
        destinoSelecionado: 1,
        setDB: this.$cookies.get("db"),
      },
      destino: [
        { id: 1, descricao: "Imprimir" },
        { id: 2, descricao: "Liberar no App para Assinatura" },
      ],
      payloadPesquisa: Object,
      printing: false,
      periodo: {
        de: "",
        ate: "",
      },
      isLoading: false,
      dados: [],
      tela: 1, //1-pesquisar, 2-resultados
    };
  },
  methods: {
    menuBreadcrumb(menu) {
      switch (menu) {
        case 0:
          this.$router.push("/home");
          break;
        case 1:
          this.payloadPesquisa = {};
          this.tela = 1;
          this.dados = [];
          break;
      }
    },
    processar() {
      switch (this.payloadEnvio.destinoSelecionado) {
        case 1:
          this.imprimirFolha();
          break;
        case 2:
          this.enviarAssinatura();
          break;
      }
    },
    enviarAssinatura() {
      const bodyFormData = { ...this.payloadPesquisa, assinatura: true };
      const th = this;
      th.isLoading = false;
      this.axios
        .post("/api/assinaturasPonto/solicitar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Solicitação de envio de assinatura enviada",
              "success",
            );
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar de envio de assinatura!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar de envio de assinatura",
            "error",
          );
        });
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    carregarCartaoDePonto(page = 1) {
      const th = this;
      const bodyFormData = {
        ...this.payloadPesquisa,
        page,
        limit: this.pagination.perPage,
      };
      this.isLoading = true;
      this.axios
        .post("/api/listarCartaoDePonto", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.dados = response.data.data.funcionarios;
            th.pagination = response.data.data.paginacao;
            th.tela = 2;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar cartão de ponto!",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar cartão de ponto!",
            "error",
          );
        });
    },
    atualizarTable() {
      this.carregarCartaoDePonto(this.pagination.currentPage); // teve alguma request e precisou atualizar. Ex: batida manual
    },
    pesquisar(event) {
      this.payloadPesquisa = event; //salva esse payload para usar caso precise atualizar a tabela depois de uma operacao
      this.periodo.de = this.payloadPesquisa.data_inicial;
      this.periodo.ate = this.payloadPesquisa.data_final;
      this.carregarCartaoDePonto(1); // emitido pelo botao pesquisar
    },
    imprimir(event) {
      console.log("Clicou em imprimir");
      console.log(event);
      console.log("-------------------");
    },
  },
  watch: {},
};
</script>
<style>
.break {
  page-break-before: always;
}
</style>
